var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-sample n1-west"},[_c('section',[_c('p',{staticClass:"default-text"},[_vm._v("\n      武皇嘯厚大禅門\n    ")])])])}]

export { render, staticRenderFns }